import { fetchNetworksConfig } from '@/api'
import getEsQuery from '../esParser'
import ElasticsearchAPI from '../../ElasticsearchAPI'

async function historicalViewership (payload) {
  const jsonQuery = payload['query']
  const NetworksData = await fetchNetworksConfig()
    let networks = NetworksData.networks || []
    networks = networks.filter(network => network.wbd === true).map(network => network.id)
  payload.networks = networks || payload.networks

  const esSearch = getEsQuery(jsonQuery, payload)
  esSearch.aggs = getHistoryAggregation(payload.viewSource, payload.networks)
  const p18search = getP18query(payload['start-date'], payload['end-date'], payload.view_source, payload.networks)

  const [qResponse, p18Response] = await Promise.all([
    ElasticsearchAPI.historicalViewership(esSearch),
    ElasticsearchAPI.historicalViewership(p18search)
  ])
  const qResults = qResponse
  const p18results = p18Response

  let netRtg = []
  let dpRtg = []
  let numP18months = -1
  let p18universe = 1

  if (p18results.aggregations) {
    const aggregation = p18results.aggregations
    if (aggregation.network_path) netRtg = aggregation['network_path']['NETWORK']['buckets']
    if (aggregation.daypart_path) dpRtg = aggregation['daypart_path']['NETWORK']['buckets']
    numP18months = aggregation.months.buckets.length
    p18universe = aggregation.universe_estimate.value
  }
  const networkP18 = {}
  for (const network of netRtg) {
    networkP18[network.key] = {rating: getRating(network.sum_avg_aud.value / numP18months, p18universe)}
  }
  for (const network of dpRtg) {
    networkP18[network.key].dayparts = {}
    for (const daypart of network.DAYPART.buckets) {
      networkP18[network.key].dayparts[daypart.key] = getRating(daypart.daypart_aa.value / numP18months, p18universe)
    }
  }

  let result = {}
  let networkBuckets = []
  let daypartBuckets = []
  let monthCnt = -1
  let universeBucket = 1

  if (qResults.aggregations.universe_estimate.value) {
    if (qResults.aggregations.network_path) networkBuckets = qResults.aggregations.network_path.NETWORK.buckets
    if (qResults.aggregations.daypart_path) daypartBuckets = qResults.aggregations.daypart_path.NETWORK.buckets
    monthCnt = qResults.aggregations.months.buckets.length
    universeBucket = qResults.aggregations.universe_estimate.value
  }
  for (const network of networkBuckets) {
    const networkName = network.key
    result[networkName] = {size: network.sum_avg_aud.value / monthCnt}
    result[networkName].rating = getRating(result[networkName].size, universeBucket)
    result[networkName].index = getIndex(result[networkName].rating, networkP18[networkName].rating)
  }
  for (const network of daypartBuckets) {
    const networkName = network.key
    result[networkName].day_parts = network.DAYPART.buckets.map(daypart => {
      const aaDaypart = daypart.daypart_aa.value / monthCnt
      const rating = getRating(aaDaypart, universeBucket)
      const val = {id: daypart.key, rating}

      if (networkP18[networkName].day_parts) {
        val.index = getIndex(rating, networkP18[networkName].day_parts[val.id])
        val.size = Math.round(aaDaypart)
      }
      return val
    })
  }
  return {data: result}
}

function getRating (aaImpressions, ue) {
  return ue !== 0 ? (aaImpressions / ue) * 100 : 0
}

function getIndex (targetRtg, baselineRtg) {
  return baselineRtg !== 0 ? Math.round((targetRtg / baselineRtg) * 100) : 0
}

function getHistoryAggregation (viewSource = 'aalivesd', networks) {
  return {
    months: {
      date_histogram: {field: 'broadcastdate', interval: 'month', format: 'yyyy-MM'},
      aggs: {ue: {sum: {field: 'intabweight'}}},
    },
    universe_estimate: {avg_bucket: {buckets_path: 'months>ue'}},
    network_path: {
      nested: {path: 'network'},
      aggs: {
        NETWORK: {
          terms: {
            field: 'network.networklabel',
            include: networks,
            size: 100
          },
          aggs: {
            sum_avg_aud: {
              sum: {
                field: `network.${viewSource}`
              }
            }
          }
        }
      },
    },
    daypart_path: {
      nested: {path: 'daypart'},
      aggs: {
        NETWORK: {
          terms: {
            field: 'daypart.networklabel',
            include: networks
          },
          aggs: {
            DAYPART: {
              terms: {field: 'daypart.reporteddaypart'},
              aggs: {daypart_aa: {sum: {field: `daypart.${viewSource}`}}},
            }
          },
        }
      },
    },
  }
}

function getP18query (startDate, endDate, viewSource, networks) {
  return {
    size: 0,
    query: {
      bool: {
        must: [
          {
            range: {
              broadcastmonthstartdate: {gte: startDate, lte: endDate, format: 'yyyy-MM-dd'}
            }
          },
          {range: {'respondent.age': {gte: 18}}},
        ]
      }
    },
    aggs: {
      months: {
        date_histogram: {field: 'broadcastdate', interval: 'month', format: 'yyyy-MM'},
        aggs: {ue: {sum: {field: 'intabweight'}}},
      },
      universe_estimate: {avg_bucket: {buckets_path: 'months>ue'}},
      network_path: {
        nested: {path: 'network'},
        aggs: {
          NETWORK: {
            terms: {
              field: 'network.networklabel',
              include: networks,
              size: 100
            },
            aggs: {
              sum_avg_aud: {
                sum: {
                  field: `network.${viewSource}`
                }
              }
            }
          }
        },
      },
      daypart_path: {
        nested: {path: 'daypart'},
        aggs: {
          NETWORK: {
            terms: {
              field: 'daypart.networklabel',
              include: networks
            },
            aggs: {
              DAYPART: {
                terms: {field: 'daypart.reporteddaypart'},
                aggs: {daypart_aa: {sum: {field: `daypart.${viewSource}`}}},
              }
            },
          }
        },
      },
    },
  }
}

export default historicalViewership



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/historicalViewership.js